import cookie from 'react-cookie';
import {
  getOffer,
  acceptOffer as claimOffer
} from '../../common/api/subscription';
import { trackEvent } from './segmentEvents';
import { stopSubmitSpinner } from './interactions';
import config from '../../config';

export const FETCH_OFFER = 'FETCH_OFFER';
export const FETCH_OFFER_SUCCESS = 'FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_FAIL = 'FETCH_OFFER_FAIL';
export const ACCEPT_OFFER = 'ACCEPT_OFFER';
export const ACCEPT_OFFER_SUCCESS = 'ACCEPT_OFFER_SUCCESS';
export const ACCEPT_OFFER_FAIL = 'ACCEPT_OFFER_FAIL';


export const fetchOffer = () => async (dispatch) => {
  dispatch({ type: FETCH_OFFER });
  try {
    const { company, funnelConfig: { _id: promotionId } } = config;
    const accessToken = cookie.load('access_token');
    const details = await getOffer(accessToken, company, promotionId);
    return dispatch({ type: FETCH_OFFER_SUCCESS, details });
  } catch (error) {
    return dispatch({ type: FETCH_OFFER_FAIL, error });
  }
};


export const acceptOffer = values => async (dispatch) => {
  dispatch({ type: ACCEPT_OFFER });
  try {
    const accessToken = cookie.load('access_token');
    const {
      brand,
      promotionId,
      source,
      selectedCard,
      defaultCardId,
    } = values;

    const offerApiValues = {
      source: source ? source.id : null,
      cardId: selectedCard !== defaultCardId ? selectedCard : defaultCardId,
    };
    await claimOffer(accessToken, brand, promotionId, offerApiValues);
    dispatch(trackEvent('Completed Checkout Step', { step: 2, promotionId }));
    dispatch(stopSubmitSpinner());
    return dispatch({ type: ACCEPT_OFFER_SUCCESS });
  } catch (error) {
    const { message } = error;
    dispatch(stopSubmitSpinner());
    return dispatch({ type: ACCEPT_OFFER_FAIL, error: message });
  }
};
